import { render, staticRenderFns } from "./DcStatusAdmin.vue?vue&type=template&id=084e1ea8&scoped=true&"
import script from "./DcStatusAdmin.vue?vue&type=script&lang=ts&"
export * from "./DcStatusAdmin.vue?vue&type=script&lang=ts&"
import style0 from "./DcStatusAdmin.vue?vue&type=style&index=0&id=084e1ea8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084e1ea8",
  null
  
)

component.options.__file = "DcStatusAdmin.vue"
export default component.exports